import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Mail } from "lucide-react";
import { NAV_LINKS } from "./Header";

export const Footer = () => (
  <footer className="bg-inkdeep text-cream" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Link to="/" className="font-display text-2xl sm:text-3xl font-bold tracking-tight">
            Noetica <span className="text-terracotta italic">Lab</span>
          </Link>
          <p className="mt-5 text-cream/60 leading-relaxed max-w-sm text-sm sm:text-base">
            Ψηφιακά εργαλεία, εκδόσεις και σεμινάρια για την επικοινωνία, τη γνωστική ενδυνάμωση και την εκπαίδευση.
          </p>
          <div className="flex items-center gap-3 mt-7">
            {[
              { icon: Facebook, label: "Facebook" },
              { icon: Instagram, label: "Instagram" },
              { icon: Linkedin, label: "LinkedIn" },
              { icon: Mail, label: "Email" },
            ].map(({ icon: Icon, label }) => (
              <a
                key={label}
                href="#"
                aria-label={label}
                data-testid={`social-${label.toLowerCase()}`}
                className="w-10 h-10 inline-flex items-center justify-center rounded-full border border-cream/20 text-cream/70 transition-colors duration-300 hover:bg-terracotta hover:border-terracotta hover:text-cream"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono2 text-xs tracking-[0.25em] uppercase text-terracotta mb-6">Πλοήγηση</p>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-cream/70 hover:text-cream transition-colors duration-300 text-sm sm:text-base">
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/epikoinonia" className="text-cream/70 hover:text-cream transition-colors duration-300 text-sm sm:text-base">
                Επικοινωνία
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-mono2 text-xs tracking-[0.25em] uppercase text-terracotta mb-6">Επικοινωνία</p>
          <ul className="space-y-3 text-cream/70 text-sm sm:text-base">
            <li>info@noeticalab.gr</li>
            <li>+30 210 000 0000</li>
            <li>Ιωάννινα, Ελλάδα</li>
          </ul>
          <div className="flex gap-6 mt-8 text-sm text-cream/50">
            <a href="#" className="hover:text-cream transition-colors duration-300" data-testid="footer-privacy">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-cream transition-colors duration-300" data-testid="footer-terms">
              Terms &amp; Conditions
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-cream/10 mt-14 pt-7 flex flex-col sm:flex-row justify-between gap-3 text-xs text-cream/40 font-mono2 tracking-wider">
        <span>© 2026 Noetica Lab. Με επιφύλαξη παντός δικαιώματος.</span>
        <span>ΕΠΙΚΟΙΝΩΝΙΑ • ΓΝΩΣΗ • ΠΡΑΞΗ</span>
      </div>
    </div>
  </footer>
);
